import { createAction } from 'redux-actions';

export const ADD_SUBSCRIPTION = 'ws/ADD_SUBSCRIPTION';
export const REMOVE_SUBSCRIPTION = 'ws/REMOVE_SUBSCRIPTION';

type SubscriptionPayload = string;

export const addSubscription = createAction<SubscriptionPayload>(ADD_SUBSCRIPTION);
export const removeSubscription = createAction<SubscriptionPayload>(REMOVE_SUBSCRIPTION);
